import {
  SELECTION_SUCCESS,
  DONT_WANT_TO_BE_REDIRECTED,
  WANT_TO_BE_REDIRECTED,
} from './types';

import initialState from './state';

export default function selectionReducer(state = initialState, action) {
  switch (action.type) {
    case SELECTION_SUCCESS:
      return {
        ...state,
        canBeRedirected: action.payload,
      };
    case DONT_WANT_TO_BE_REDIRECTED:
      return {
        ...state,
        canBeRedirected: false,
      };
    case WANT_TO_BE_REDIRECTED:
      return {
        ...state,
        isRedirected: true,
      };
    default:
      return state;
  }
}
